
import React from 'react';
import SketchPicker from "../../Common/colorPicker";
import CustomSelect from '../../Common/customSelect';


const ShirtSettings = ({props}) => {

    return (
        <div >
        <div className="well" style={{margin:"10px",background:"ghostwhite"}}>       
        <label style={{fontWeight:"bold",fontSize:'18px'}}>Choose your shirt</label>
        <hr className="rounded" style={{backgroundColor:"black",width:"60%",marginTop:"0px"}}/>

        <select style={{background:"aliceblue",width:"100%",borderTop:"none",borderRight:"none",borderLeft:"none",fontSize:"22px"}} id="selectedType" value={props.designer.selectedShirtType.value} onChange={(e)=>{var price=270; if(e.target.value==='Long Sleeves Shirt') price=130;props.onSelectedShirtTypeChange({type:e.target.value,price});props.designer.drawingCanvas.clear();props.setFrontCanvasJson(JSON.stringify(props.designer.drawingCanvas));props.setBackCanvasJson(JSON.stringify(props.designer.drawingCanvas));
                      ;}}>                        
            {props.designer.availableShirtTypes.map((shirt,index)=>(<option key={index} value={shirt.value}>{shirt.name}</option>))}  

        </select>
        </div>


        <div className="well" style={{margin:"10px",background:"ghostwhite"}}>       
        <label style={{fontWeight:"bold",fontSize:'18px'}}>Measurment</label>
        <hr className="rounded" style={{backgroundColor:"black",width:"60%",marginTop:"0px"}}/>

        <select style={{background:"aliceblue",width:"100%",borderTop:"none",borderRight:"none",borderLeft:"none",fontSize:"22px"}} id="selectedType"  onChange={(e)=>{var temp=JSON.parse(e.target.value); props.setAvailableColors(temp.colors);props.setPrice(temp.price);props.setSize(temp.value)}}>    
        <option  value={undefined}>Choose your measurment</option>                    
            {props.designer.selectedShirtType.availableSizes.map((shirt,index)=>(<option key={index}  value={JSON.stringify({colors:shirt.colors,price:shirt.price,value:shirt.value})}>{shirt.descibtion}</option>))}  

        </select>
        </div>

        <hr className="rounded" style={{backgroundColor:"black",width:"60%",margin:"auto",marginTop:"10px"}}/>
        <div className="well"  style={{margin:"10px",background:"ghostwhite"}}>
        <label style={{width:"100%",fontWeight:"bold",fontSize:'18px'}}>Choose your Color</label>
        <hr className="rounded" style={{backgroundColor:"black",width:"60%",marginTop:"0px"}}/>
        
        <SketchPicker onColorChanged={props.onSelectedColorChange} props={props}/>



				
	
        </div>	
        </div>		   				
							
        );
}
 
export default ShirtSettings;
